import { FormattedMessage } from 'gatsby-plugin-intl';
import * as React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';

import { useIsRtl } from '../../../hooks/useIsRtl';
import { Counter } from '../../common/Counter';
import { Flex } from '../../common/Flex';
import { Indent } from '../../common/Indent';
import { StyledText } from '../../common/StyledText';
import { TitleLine } from '../../common/TitleLine';

export const Counters = () => {
  const isRtl = useIsRtl();

  return (
    <Row reverse={isRtl}>
      <Col xs={12} md={12}>
        <Flex justify='center'>
          <Indent vertical={2.5}>
            <Flex direction='column' align='center'>
              <Indent bottom={2}>
                <h2>
                  <StyledText
                    color='textInverted'
                    size='2'
                    smSize='2.625'
                    lineHeight='1.2'
                    align='center'
                    type='inline-block'>
                    <FormattedMessage id='homepage.counters.title' />
                  </StyledText>
                </h2>
              </Indent>
              <Indent smBottom={0.5} width='100%'>
                <Flex justify='center'>
                  <TitleLine width='80%' />
                </Flex>
              </Indent>
            </Flex>
          </Indent>
        </Flex>
      </Col>
      <Col xs={12} lg={8} lgOffset={2}>
        <Flex align='flex-end' direction='column' justify='space-between' xsDirection='row' xsAlign='flex-end'>
          <div
            style={{
              flex: '1 1 33.3%',
            }}>
            <Counter title='homepage.counters.webmasters' postfix='k' value={79} percent={73} />
          </div>
          <div
            style={{
              flex: '1 1 33.3%',
            }}>
            <Counter title='homepage.counters.social' prefix='1:' value={26} percent={100} primary />
          </div>
          <div
            style={{
              flex: '1 1 33.3%',
            }}>
            <Counter title='homepage.counters.payments' postfix='M' value={1.23} percent={61} />
          </div>
        </Flex>
      </Col>
    </Row>
  );
};
